import { render, staticRenderFns } from "./TheNotificationConfiguration.vue?vue&type=template&id=7b76a948&scoped=true"
import script from "./TheNotificationConfiguration.vue?vue&type=script&lang=js"
export * from "./TheNotificationConfiguration.vue?vue&type=script&lang=js"
import style0 from "./TheNotificationConfiguration.vue?vue&type=style&index=0&id=7b76a948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b76a948",
  null
  
)

export default component.exports